import React from 'react';
import Stack from '@mui/joy/Stack';

import { NavItemLinkProps } from './NavToggleGroup';
import Social from './Social';

const socials: NavItemLinkProps<any>[] = [
  {
    to: 'instagram',
    id: 'HannahVonStevens',
  },
  {
    to: 'youtube',
    id: 'HannahVonStevens',
  },
  {
    to: 'soundcloud',
    id: 'HannahVonStevens',
  },
  {
    to: 'snapchat',
    id: 'HannahVonSteven',
  },
  {
    to: 'twitter',
    id: 'HannahVonSteven',
  },
  {
    to: 'facebook',
    id: 'HannahVonStevens',
  },
];

export interface SocialProps extends React.HTMLAttributes<HTMLDivElement> {}

function SocialBox(props: SocialProps) {
  const { className } = props;
  return (
    <Stack
      direction="row"
      className={className}
      flexWrap="wrap"
      spacing={1}
      useFlexGap
    >
      {socials.map((x) => (
        <Social key={`${x.to}-${x.id}`} {...x} />
      ))}
    </Stack>
  );
}

export default React.memo(SocialBox);
